<button mat-icon-button class="close-button" (click)="close()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<mat-progress-bar mode="indeterminate" *ngIf="salvando"></mat-progress-bar>
<div mat-dialog-content>
  <mat-card class="p-0">
    <form [formGroup]="produtoForm" *ngIf="produtoForm">
      <!-- Barra de inclusão: lista, tabela, preço inicial e Adicionar -->
      <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="8px" class="form-section">
        <!-- Lista de Preço -->
        <div fxFlex="100" fxFlex.gt-sm="30" fxFlex.sm="30" fxFlex.lt-md="100">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Lista de Preço:</mat-label>
            <mat-select [formControl]="produtoForm?.controls['lista']!" (selectionChange)="this.changeLista()">
              <mat-option *ngFor="let lista of listaPrecos" [value]="lista">
                {{lista.id.toString().padStart(5,'0') + " - " + lista.descricao}}
              </mat-option>
            </mat-select>
            <mat-hint>Somente listas da filial do produto</mat-hint>
          </mat-form-field>
        </div>

        <!-- Tabela de Preço -->
        <div fxFlex="100" fxFlex.gt-sm="30" fxFlex.sm="30" fxFlex.lt-md="100">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Tabela de Preço:</mat-label>
            <mat-select [formControl]="produtoForm?.controls['tabela']!">
              <mat-option *ngFor="let tabela of tabelas$ | async" [value]="tabela">
                {{tabela.id.tabelaId.toString().padStart(5,'0') + " - " + tabela.descricao}}
              </mat-option>
            </mat-select>
            <mat-hint *ngIf="!(tabelas$ | async)?.length">Selecione uma lista para ver as tabelas</mat-hint>
          </mat-form-field>
        </div>

        <!-- Preço inicial -->
        <div fxFlex="100" fxFlex.gt-sm="20" fxFlex.sm="20" fxFlex.lt-md="100">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Preço</mat-label>
            <input matInput type="text" (focus)="$event.target.select()"
              (keyup.enter)="incluirPreco(novoPreco)"
              [formControl]="produtoForm?.controls['preco']!" currencyMask
              [options]="{ prefix: 'R$ ', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }" />
          </mat-form-field>
        </div>

        <!-- Botão Adicionar -->
        <div fxFlex="100" fxFlex.gt-sm="15" fxFlex.sm="15" fxFlex.lt-md="100" class="button-container"
          style="height: 60px;">
          <button mat-raised-button color="primary" (click)="incluirPreco(novoPreco)" class="full-width-button"
            [disabled]="salvando || !produtoForm?.controls['tabela']?.value"
            matTooltip="Adiciona a tabela selecionada já com o preço digitado">
            <mat-icon>add_circle</mat-icon> Adicionar
          </button>
        </div>
      </div>

      <!-- Nenhum preço -->
      <div class="empty-state" *ngIf="!(precos$ | async)?.length">
        <mat-icon>local_offer</mat-icon>
        <div>Nenhum preço cadastrado para este produto.</div>
        <small>Escolha a lista e a tabela acima, informe o preço e clique em Adicionar.</small>
      </div>

      <!-- Seção de Cards de Preços -->
      <div fxLayout="row wrap" fxLayoutGap="16px" class="precos-section">
        <div *ngFor="let preco of precos" fxFlex="100" fxFlex.gt-sm="48" fxFlex.sm="100" fxFlex.lt-md="100">
          <mat-card class="user-card" [class.card-custo]="isCusto(preco)">
            <mat-card-title>
              <div class="card-title-text">
                <span class="titulo-lista">
                  {{ preco?.listaPreco.id.toString().padStart(5,'0') + " - " + preco?.listaPreco?.descricao }}
                </span>
                <span fxFlex></span>
                <span class="chip chip-base" *ngIf="isTabelaBase(preco)" matTooltip="Tabela base: propaga às seguintes">BASE</span>
                <span class="chip chip-custo" *ngIf="isCusto(preco)" matTooltip="Valor vindo do custo do saldo">CUSTO</span>
                <span class="chip chip-promo" *ngIf="temPromocao(preco)"
                  [matTooltip]="'Promoção até ' + (preco?.validadePromocao | date:'dd/MM/yyyy')">PROMO</span>
              </div>
              <mat-divider></mat-divider>
            </mat-card-title>
            <mat-card-content>
              <div class="user-details">
                <div class="linha-tabela">
                  <mat-icon class="icone-linha">table_chart</mat-icon>
                  {{ preco?.tabela?.id.tabelaId.toString().padStart(5,'0') + " - " + preco?.tabela?.descricao }}
                </div>

                <!-- Preço: leitura (clique edita) / edição inline -->
                <div class="linha-preco" *ngIf="!emEdicao(preco)">
                  <div class="valor" [class.clicavel]="!isCusto(preco)" (click)="iniciarEdicaoInline(preco)"
                    [matTooltip]="isCusto(preco) ? 'Custo do saldo: não editável aqui' : 'Clique para alterar o preço'">
                    {{ (preco?.preco || 0) | currency:'BRL' }}
                    <mat-icon class="icone-editar" *ngIf="!isCusto(preco)">edit</mat-icon>
                  </div>
                  <div class="valor-promo" *ngIf="temPromocao(preco)">
                    Promocional: {{ preco?.precoPromocao | currency:'BRL' }}
                    <small>até {{ preco?.validadePromocao | date:'dd/MM/yyyy' }}</small>
                  </div>
                </div>

                <div class="linha-preco" *ngIf="emEdicao(preco)">
                  <mat-form-field appearance="outline" class="campo-inline">
                    <mat-label>Preço</mat-label>
                    <input matInput type="text" cdkFocusInitial [(ngModel)]="precoEmEdicao"
                      [ngModelOptions]="{standalone: true}" (focus)="$event.target.select()"
                      (keyup.enter)="salvarEdicaoInline(preco)" (keyup.escape)="cancelarEdicaoInline()" currencyMask
                      [options]="{ prefix: 'R$ ', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }" />
                  </mat-form-field>
                  <button mat-icon-button color="primary" matTooltip="Salvar (Enter)" [disabled]="salvando"
                    (click)="salvarEdicaoInline(preco)">
                    <mat-icon>check_circle</mat-icon>
                  </button>
                  <button mat-icon-button matTooltip="Cancelar (Esc)" (click)="cancelarEdicaoInline()">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </div>

                <div class="linha-obs" *ngIf="preco?.observacao">
                  <mat-icon class="icone-linha">notes</mat-icon>{{ preco?.observacao }}
                </div>
              </div>
            </mat-card-content>
            <mat-card-actions class="card-actions" *ngIf="!isCusto(preco)">
              <button mat-button color="primary" matTooltip="Promoção, validade e observação"
                (click)="openProdutoPrecoPopUp(preco);$event.preventDefault();">
                <mat-icon>local_offer</mat-icon> Promoção / Obs.
              </button>
              <span fxFlex></span>
              <button mat-icon-button color="warn" matTooltip="Excluir preço" [disabled]="salvando"
                (click)="$event.preventDefault();deletePreco(preco)">
                <mat-icon>delete</mat-icon>
              </button>
            </mat-card-actions>
          </mat-card>
        </div>
      </div>
    </form>
  </mat-card>
</div>
<mat-dialog-actions>
  <div fxFlex="100" class="mt-1">
    <span fxFlex></span>
    <button mat-button color="warn" type="button" (click)="close()">
      <mat-icon>close</mat-icon>{{ "CLOSE" | translate }}
    </button>
  </div>
</mat-dialog-actions>
